module.exports = __webpack_public_path__ + "static/media/list.dc23d4c2.svg";